import { ReactElement } from 'react'
import styled, { css } from 'styled-components'
import { TicketKind, TicketType, ticketKind, ticketKindLabel } from '../format'
import { colors, fontScope, radius } from '../tokens'

const KIND_STYLES: Record<TicketKind, { background: string, color: string }> = {
  inteira: { background: colors.badgeDark, color: colors.white },
  meia: { background: colors.badgeMuted, color: '#000000' },
  cortesia: { background: colors.courtesyBg, color: colors.primaryStrong },
}

const Badge = styled.span<{ $kind: TicketKind, $compact: boolean }>`
  ${fontScope}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${radius.badge};
  white-space: nowrap;
  background: ${({ $kind }) => KIND_STYLES[$kind].background};
  color: ${({ $kind }) => KIND_STYLES[$kind].color};
  ${({ $compact }) =>
    $compact
      ? css`
          padding: 4px 8px;
          font-size: 10px;
          font-weight: 700;
          line-height: normal;
        `
      : css`
          padding: 8px 16px;
          font-size: 12px;
          font-weight: 600;
          line-height: 18px;
          letter-spacing: 0.12px;
        `}
`

interface TipoBadgeProps {
  ticketType: TicketType
  courtesy: boolean
  compact?: boolean
}

export function TipoBadge({ ticketType, courtesy, compact = false }: TipoBadgeProps): ReactElement {
  const kind = ticketKind(ticketType, courtesy)
  return (
    <Badge $kind={kind} $compact={compact}>
      {ticketKindLabel(kind)}
    </Badge>
  )
}
